import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function FormIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      id="Form"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
    >
      <path
        id="Path_10156"
        data-name="Path 10156"
        d="M17.444,3H5.222A2.229,2.229,0,0,0,3,5.222V20.778A2.229,2.229,0,0,0,5.222,23H20.778A2.229,2.229,0,0,0,23,20.778V8.556Zm3.333,17.778H5.222V5.222H16.333V9.667h4.444ZM7.444,18.556H18.556V16.333H7.444ZM13,7.444H7.444V9.667H13ZM7.444,14.111H18.556V11.889H7.444Z"
        transform="translate(-3 -3)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
